export const getCurrentWeekStart = () => {
  const now = new Date();
  const day = now.getDay();
  const offset = (day === 0 ? -6 : 1) - day;
  const monday = new Date(
    now.getFullYear(),
    now.getMonth(),
    now.getDate() + offset
  );
  monday.setHours(0, 0, 0, 0);
  return monday;
};
